import React from "react";
import { StyleSheet, SafeAreaView, Platform } from "react-native";
import variables from "../../styles/variables";

export default function RtvSafeView({ children, color, styleOverrides = {} }) {
  return (
    <SafeAreaView
      style={[
        styles.container,
        color ? { backgroundColor: color } : {},
        styleOverrides,
      ]}
    >
      {children}
    </SafeAreaView>
  );
}

// Normal RN Safe area view does not work correctly on android

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexGrow: 1,
    minHeight: "100%",
    paddingTop: 0,
    marginTop: Platform.OS === "ios" ? -15 : 0,
  },
});
